import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { setLanguage, SUPPORTED_LANGUAGES } from '../i18n';
import { apiSetLanguage } from '../utils/api';
import { useAuth } from './useAuth';

// Single entry point for the language switcher (used both on the public site
// and inside the Vault). Always flips the UI + localStorage immediately;
// additionally persists to the user's profile (so it's the same on every
// device, and is what mailer.js picks for transactional emails) when logged
// in. The server call is best-effort — a failure shouldn't block the UI
// switch, it just means the next apiMe()/login will resync it.
export function useLanguage() {
  const { i18n } = useTranslation();
  const { user, isAuthenticated, refreshUser } = useAuth();

  const changeLanguage = useCallback((lang) => {
    if (!SUPPORTED_LANGUAGES.includes(lang)) return;
    setLanguage(lang);
    if (isAuthenticated && user && user.language !== lang) {
      refreshUser({ ...user, language: lang });
      apiSetLanguage(lang).catch(() => {});
    }
  }, [isAuthenticated, user, refreshUser]);

  return { language: i18n.language, changeLanguage, supported: SUPPORTED_LANGUAGES };
}
